import { useState } from 'react';
import XenieLogoDark from "../../Assets/XenieLogoDark.png";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Eye from '../../Assets/eye.svg';
import EyeOff from '../../Assets/eyeIconOff.svg';
import Success from '../../Assets/success.gif';
import { changePasswordOfUser } from '../../lib/utils/apiCalls';
import { showToast } from '../../Components/Toaster/Toaster';
import Error from '../Error/Error.Page';

function ChangePassword() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    const navigate = useNavigate();

    const [passReset, setPassReset] = useState(false);

    const defaultFormErrors = {
        password: '',
        confirmPassword: ''
    }

    const defaultFormFields = {
        password: '',
        confirmPassword: ''
    }

    const [formInputs, setFormInputs] = useState(defaultFormFields);
    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setFormInputs({...formInputs, [name]: value});
    }

    const [visiblePassword, setVisiblePassword] = useState(false);
    const [visibleConfirmPassword, setVisibleConfirmPassword] = useState(false);

    const handlePasswordEye = (e) => {
        e.preventDefault();
        setVisiblePassword(!visiblePassword);
    }

    const handleConfirmPasswordEye = (e) => {
        e.preventDefault();
        setVisibleConfirmPassword(!visibleConfirmPassword);
    }

    const handleSigninClick = () => {
        navigate('/signin');
    }

    const handleButtonClick = async (e) => {
        e.preventDefault();
        const validationErrors = {};

        if(!formInputs.password.trim()) {
            validationErrors.password = 'Password is required';
        }

        if(!formInputs.confirmPassword.trim()) {
            validationErrors.confirmPassword = 'Confirm password is required';
        }
        else if(formInputs.password !== formInputs.confirmPassword) {
            validationErrors.confirmPassword = 'Password doesn\'t match';
        }

        if(Object.keys(validationErrors).length === 0) {
            setFormErrors(defaultFormErrors);

            const callData = {
                id: id,
                newPassword: formInputs.password,
                confirmNewPassword: formInputs.confirmPassword
            };

            const response = await changePasswordOfUser(callData);

            // eslint-disable-next-line eqeqeq
            if(response.statusCode == '10001') {
                // setFormErrors({
                //     ...formErrors,
                //     confirmPassword: 'Error changing password'
                // });
                showToast('Error changing password', 'error');
            }
            // eslint-disable-next-line eqeqeq
            else if(response.statusCode == '10000') {
                setPassReset(true);
            }
        }
        else {
            setFormErrors(validationErrors);
            return;
        }
    }

    if(!id) {
        return <Error />;
    }

    return (
        <div className='max-w-screen h-screen flex justify-center pb-16 overflow-y-scroll'>
            <div className="mt-[112px] w-[44%] h-fit p-10 bg-[#FFFFFF] border border-[#EAEAEA] rounded-2xl flex flex-col items-center gap-20">
                <div className="h-11 w-auto">
                    <img className='h-full w-auto mx-auto' src={XenieLogoDark} alt="Xenie Logo" />
                </div>

                <>
                    {
                        !passReset ? 
                        <div className="flex flex-col gap-6 w-full">
                            <div className="flex flex-col gap-6">
                                <div className="flex flex-col">
                                    <h1 className='font-semibold text-[32px] leading-[44px] text-[#121212]'>Change Password</h1>

                                    <p className='font-medium text-base text-[#666666]'>Create a new password.</p>
                                </div>

                                <form className="flex flex-col gap-8">
                                    <div className="flex flex-col gap-3">
                                        <div className="flex flex-col gap-2">
                                            <label className='font-medium text-base text-[#121212]' htmlFor="password">New Password</label>

                                            <div className="rounded-[9px] bg-[#F5F5F5] border border-[#EAEAEA] px-3 py-4 flex items-center gap-[10px]">
                                                <input
                                                    className='w-[calc(100%-24px)] bg-transparent outline-none font-normal text-base text-[#121212] placeholder:text-[#666666]' 
                                                    placeholder='Enter new password' 
                                                    id='password' 
                                                    type={visiblePassword ? 'text' : 'password'} 
                                                    name='password' 
                                                    autoComplete='off'
                                                    value={formInputs.password} 
                                                    onChange={changeHandler} 
                                                />

                                                <button onClick={handlePasswordEye} className="outline-none w-6 h-6 flex items-center justify-center">
                                                    <img src={visiblePassword ? Eye : EyeOff} alt="" />
                                                </button>
                                            </div>

                                            {formErrors.password && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.password}</p>}
                                        </div>

                                        <div className="flex flex-col gap-2">
                                            <label className='font-medium text-base text-[#121212]' htmlFor="confirmPassword">Confirm Password</label>

                                            <div className="rounded-[9px] bg-[#F5F5F5] border border-[#EAEAEA] px-3 py-4 flex items-center gap-[10px]">
                                                <input
                                                    className='w-[calc(100%-24px)] bg-transparent outline-none font-normal text-base text-[#121212] placeholder:text-[#666666]' 
                                                    placeholder='Confirm new password' 
                                                    id='confirmPassword' 
                                                    type={visibleConfirmPassword ? 'text' : 'password'} 
                                                    name='confirmPassword' 
                                                    autoComplete='off' 
                                                    value={formInputs.confirmPassword} 
                                                    onChange={changeHandler} 
                                                />

                                                <button onClick={handleConfirmPasswordEye} className="outline-none w-6 h-6 flex items-center justify-center">
                                                    <img src={visibleConfirmPassword ? Eye : EyeOff} alt="" />
                                                </button>
                                            </div>

                                            {formErrors.confirmPassword && <p className='text-[14px] leading-5 text-[#DC2626]'>{formErrors.confirmPassword}</p>}
                                        </div>
                                    </div>

                                    <button onClick={handleButtonClick} className='outline-none font-semibold text-[18px] leading-6 text-buttonText rounded-[9px] px-3 py-4 bg-primaryColor hover:bg-primaryAccent'>Change password</button>
                                </form>
                            </div>

                            <p className="font-medium text-[14px] leading-6 mx-auto text-[#000000]">Back to <Link className='font-semibold text-link hover:underline' to='/signin'>Sign-in</Link></p>
                        </div> : 
                        <div className="flex flex-col items-center gap-6 w-full">
                            <div className="w-[200px] h-[200px] flex items-center justify-center">
                                <img className='w-full h-full' src={Success} alt="" />
                            </div>

                            <div className="flex flex-col gap-8 w-full">
                                <div className="flex flex-col items-center select-none">
                                    <h1 className='font-semibold text-[32px] leading-[44px] text-[#121212]'>Password Reset</h1>

                                    <div className='font-medium text-base text-[#666666] flex flex-col items-center'>
                                        <p>Your password has been successfully changed.</p>

                                        <p>Click below to Sign-in</p>
                                    </div>
                                </div>

                                <button onClick={handleSigninClick} className='outline-none font-semibold text-[18px] leading-6 text-[#FFFFFF] rounded-[9px] px-3 py-4 bg-primaryColor hover:bg-primaryAccent'>Sign in</button>
                            </div>
                        </div>
                    }
                </>
            </div>
        </div>
    );
}

export default ChangePassword;
